export const initNextSteps = () => {
  const nextSteps = document.getElementById("next-steps") as HTMLDivElement;

  if (!nextSteps) {
    return;
  }

  const steps: NodeListOf<HTMLDivElement> = nextSteps.querySelectorAll(".step");

  steps.forEach((step) => {
    const button = step.querySelector("button") as HTMLButtonElement;
    const body = step.querySelector(".body") as HTMLDivElement;
    const icon = step.querySelector(".icon") as HTMLDivElement;

    button.addEventListener("click", () => {
      body.classList.toggle("d-none");
      icon.classList.toggle("d-none");
    });
  });
};
